var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 412.602H853.393V534.779L780.204 486.404L673.861 531.677L566.264 486.403L473.058 572.61L372.342 601.14L327.928 564.548L292.897 511.831L259.742 543.462L185.926 482.062L134.63 489.505L77.08 440.509L2.63965 421.904L3.264 412.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 412.602V413.203H852.787V533.655L780.267 485.722L673.859 531.023L566.139 485.697L472.75 572.071L372.483 600.474L328.385 564.142L293.001 510.896L259.714 542.653L186.108 481.428L134.816 488.869L77.3663 439.961L3.27796 421.443L3.86903 412.642L3.26384 412.602V413.203V412.602L2.65865 412.562L2 422.364L76.7934 441.058L134.445 490.14L185.745 482.697L259.769 544.27L292.792 512.767L327.47 564.953L372.201 601.805L473.364 573.148L566.39 487.109L673.861 532.331L780.141 487.085L854 535.903V412H2.69597L2.65865 412.562L3.26384 412.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 412.602V413.203H852.787V533.655L780.267 485.722L673.859 531.023L566.139 485.697L472.75 572.071L372.483 600.474L328.385 564.142L293.001 510.896L259.714 542.653L186.108 481.428L134.816 488.869L77.3663 439.961L3.27796 421.443L3.86903 412.642L3.26384 412.602ZM3.26384 412.602V413.203V412.602ZM3.26384 412.602L2.65865 412.562L2 422.364L76.7934 441.058L134.445 490.14L185.745 482.697L259.769 544.27L292.792 512.767L327.47 564.953L372.201 601.805L473.364 573.148L566.39 487.109L673.861 532.331L780.141 487.085L854 535.903V412H2.69597L2.65865 412.562L3.26384 412.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3058_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.74 242.33H614.74V257.53H697.74V242.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.81 589.87H560.21V767.33H637.81V589.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.65 435.71V768.61H639.22L639.51 407.08",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.65 435.71V768.61H639.22L639.51 407.08",
    stroke: "#F7F9F9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.22 759.67L488.57 754.67L558.93 750.56",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.22 759.67L488.57 754.67L558.93 750.56",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.22 735.84L488.29 731.72L558.93 726.72",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.22 735.84L488.29 731.72L558.93 726.72",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.66 725.34L707.46 731.01L638.66 736.4",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.66 725.34L707.46 731.01L638.66 736.4",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.22 749.6L707.74 756.6L639.08 760.99",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.22 749.6L707.74 756.6L639.08 760.99",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.79 411.41L558.65 434.96L636.65 422.34V411.27L558.79 411.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.88 672.71H560.07V693.13H586.88V672.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.13 505.18L579.35 431.9L619.91 424.72V500.93L579.13 505.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.74 356.55H558.02V371.75H836.74V356.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.74 282.49H146.02V297.69H374.74V282.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.74 282.49H440.74V297.69H494.74V282.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.74 282.49H529.74V297.69H583.74V282.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.74 281.33H375.02V298.86H382.74V281.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.02 281.83H396.85L402.74 275.08L413.74 285.08L400.74 298.36H383.02V281.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.74 281.33H438.02V298.86H445.74V281.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.74 281.33H492.02V298.86H530.74V281.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.74 298.36H428.02L394.74 267.08L405.74 256.08L434.74 281.83H437.74V298.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.39 275.08H580.89V307.02H621.39V275.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.05 264.08H584.22V275.08H618.05V264.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.55 237.08H585.72V263.08H616.55V237.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.74 236.93H695.72V262.93H702.74V236.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.74 236.93H702.72V262.93H709.74V236.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.25 348.93H719.74V379.08H727.25V348.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.74 348.93H727.23V379.08H734.74V348.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.64 232.08H586.64V237.08H615.64V232.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.91 394.52H561.91V404.52H636.91V394.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.71 402.52H557.71V411.52H640.71V402.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.01 333.42H571.61V394.32H630.01V333.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.01 338.62H563.01V342.12H569.01V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.61 338.62H571.61V342.12H577.61V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.31 338.62H580.31V342.12H586.31V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.91 338.62H588.91V342.12H594.91V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.51 338.62H597.51V342.12H603.51V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.21 338.62H606.21V342.12H612.21V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.81 338.62H614.81V342.12H620.81V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.41 338.62H623.41V342.12H629.41V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.11 338.62H632.11V342.12H638.11V338.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.51 303.82H557.71V339.12H643.51V303.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.01 300.62H563.01V304.12H569.01V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.61 300.62H571.61V304.12H577.61V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.31 300.62H580.31V304.12H586.31V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.91 300.62H588.91V304.12H594.91V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.51 300.62H597.51V304.12H603.51V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.21 300.62H606.21V304.12H612.21V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.81 300.62H614.81V304.12H620.81V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.41 300.62H623.41V304.12H629.41V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.11 300.62H632.11V304.12H638.11V300.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.31 333.62C602.574 333.62 604.41 331.784 604.41 329.52C604.41 327.256 602.574 325.42 600.31 325.42C598.046 325.42 596.21 327.256 596.21 329.52C596.21 331.784 598.046 333.62 600.31 333.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.74 321.08H643.54H557.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.74 321.08H643.54",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.07 672.71H613.12V693.13H640.07V672.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.24 273.58H296.16V282.08H320.24V273.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.91 271.89C313.897 271.89 318.75 267.037 318.75 261.05C318.75 255.063 313.897 250.21 307.91 250.21C301.924 250.21 297.07 255.063 297.07 261.05C297.07 267.037 301.924 271.89 307.91 271.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2 271.83C314.181 271.83 319.03 266.981 319.03 261C319.03 255.019 314.181 250.17 308.2 250.17C302.219 250.17 297.37 255.019 297.37 261C297.37 266.981 302.219 271.83 308.2 271.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.01 260.74L312.74 254.08L308.01 260.74Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.01 260.74L312.74 254.08",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.2 262.5C308.973 262.5 309.6 261.873 309.6 261.1C309.6 260.327 308.973 259.7 308.2 259.7C307.427 259.7 306.8 260.327 306.8 261.1C306.8 261.873 307.427 262.5 308.2 262.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.62 273.73H205.54V282.23H229.62V273.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.58 271.98C223.561 271.98 228.41 267.131 228.41 261.15C228.41 255.169 223.561 250.32 217.58 250.32C211.599 250.32 206.75 255.169 206.75 261.15C206.75 267.131 211.599 271.98 217.58 271.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38 260.9L222.12 254.23L217.38 260.9Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38 260.9L222.12 254.23",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.58 262.65C218.353 262.65 218.98 262.023 218.98 261.25C218.98 260.477 218.353 259.85 217.58 259.85C216.806 259.85 216.18 260.477 216.18 261.25C216.18 262.023 216.806 262.65 217.58 262.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.737 254.052L377.733 256.05L389.215 267.564L391.219 265.565L379.737 254.052Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.749 246.045L382.735 251.044L394.217 262.558L399.23 257.559L387.749 246.045Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.744 242.043L387.736 246.039L399.218 257.553L403.226 253.556L391.744 242.043Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.735 251.045L379.726 254.046L391.207 265.559L394.216 262.558L382.735 251.045Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.734 240.053L391.73 242.051L403.212 253.565L405.216 251.566L393.734 240.053Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.26 235.563L373.232 249.551L378.705 255.039L392.732 241.051L387.26 235.563Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.261 228.559L366.233 242.547L371.706 248.035L385.733 234.047L380.261 228.559Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.735 231.054L368.229 234.549L371.223 237.552L374.728 234.056L371.735 231.054Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.793 253.094L390.774 268.071L392.73 270.032L407.749 255.055L405.793 253.094Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.789 233.104L370.771 248.081L372.726 250.042L387.745 235.066L385.789 233.104Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.263 229.585L366.761 235.072L367.227 235.539L372.729 230.053L372.263 229.585Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.82 272.96H498.74V281.46H522.82V272.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.78 271.2C516.761 271.2 521.61 266.351 521.61 260.37C521.61 254.389 516.761 249.54 510.78 249.54C504.799 249.54 499.95 254.389 499.95 260.37C499.95 266.351 504.799 271.2 510.78 271.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.59 260.08L515.32 253.42L510.59 260.08Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.59 260.08L515.32 253.42",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.78 261.87C511.553 261.87 512.18 261.243 512.18 260.47C512.18 259.697 511.553 259.07 510.78 259.07C510.007 259.07 509.38 259.697 509.38 260.47C509.38 261.243 510.007 261.87 510.78 261.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.031 274.66C672.589 274.66 683.581 263.669 683.581 250.11C683.581 236.551 672.589 225.56 659.031 225.56C645.472 225.56 634.48 236.551 634.48 250.11C634.48 263.669 645.472 274.66 659.031 274.66Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.03 265.78C667.685 265.78 674.7 258.764 674.7 250.11C674.7 241.456 667.685 234.44 659.03 234.44C650.376 234.44 643.36 241.456 643.36 250.11C643.36 258.764 650.376 265.78 659.03 265.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.03 258.11C663.449 258.11 667.03 254.528 667.03 250.11C667.03 245.692 663.449 242.11 659.03 242.11C654.612 242.11 651.03 245.692 651.03 250.11C651.03 254.528 654.612 258.11 659.03 258.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.74 246.73C650.259 246.73 651.49 245.499 651.49 243.98C651.49 242.461 650.259 241.23 648.74 241.23C647.221 241.23 645.99 242.461 645.99 243.98C645.99 245.499 647.221 246.73 648.74 246.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.94 241.73C656.459 241.73 657.69 240.499 657.69 238.98C657.69 237.461 656.459 236.23 654.94 236.23C653.422 236.23 652.19 237.461 652.19 238.98C652.19 240.499 653.422 241.73 654.94 241.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.94 241.73C664.459 241.73 665.69 240.499 665.69 238.98C665.69 237.461 664.459 236.23 662.94 236.23C661.422 236.23 660.19 237.461 660.19 238.98C660.19 240.499 661.422 241.73 662.94 241.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.74 246.73C670.259 246.73 671.49 245.499 671.49 243.98C671.49 242.461 670.259 241.23 668.74 241.23C667.221 241.23 665.99 242.461 665.99 243.98C665.99 245.499 667.221 246.73 668.74 246.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.74 253.33C672.259 253.33 673.49 252.099 673.49 250.58C673.49 249.061 672.259 247.83 670.74 247.83C669.221 247.83 667.99 249.061 667.99 250.58C667.99 252.099 669.221 253.33 670.74 253.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.24 253.33C648.759 253.33 649.99 252.099 649.99 250.58C649.99 249.061 648.759 247.83 647.24 247.83C645.721 247.83 644.49 249.061 644.49 250.58C644.49 252.099 645.721 253.33 647.24 253.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.34 259.98C669.859 259.98 671.09 258.749 671.09 257.23C671.09 255.711 669.859 254.48 668.34 254.48C666.821 254.48 665.59 255.711 665.59 257.23C665.59 258.749 666.821 259.98 668.34 259.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.74 260.08C651.259 260.08 652.49 258.849 652.49 257.33C652.49 255.811 651.259 254.58 649.74 254.58C648.221 254.58 646.99 255.811 646.99 257.33C646.99 258.849 648.221 260.08 649.74 260.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.74 264.43C664.259 264.43 665.49 263.199 665.49 261.68C665.49 260.161 664.259 258.93 662.74 258.93C661.221 258.93 659.99 260.161 659.99 261.68C659.99 263.199 661.221 264.43 662.74 264.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.74 264.43C657.259 264.43 658.49 263.199 658.49 261.68C658.49 260.161 657.259 258.93 655.74 258.93C654.221 258.93 652.99 260.161 652.99 261.68C652.99 263.199 654.221 264.43 655.74 264.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.14 266.31L658.74 250.08L640.14 266.31Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.14 266.31L658.74 250.08",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.23 249.63L680.59 260.08L658.23 249.63Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.23 249.63L680.59 260.08",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.42 225.57L658.66 250.15L656.42 225.57Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.42 225.57L658.66 250.15",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.49 388.49C695.049 388.49 706.04 377.498 706.04 363.94C706.04 350.381 695.049 339.39 681.49 339.39C667.932 339.39 656.94 350.381 656.94 363.94C656.94 377.498 667.932 388.49 681.49 388.49Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.49 379.61C690.145 379.61 697.16 372.594 697.16 363.94C697.16 355.286 690.145 348.27 681.49 348.27C672.836 348.27 665.82 355.286 665.82 363.94C665.82 372.594 672.836 379.61 681.49 379.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.49 371.94C685.909 371.94 689.49 368.358 689.49 363.94C689.49 359.522 685.909 355.94 681.49 355.94C677.072 355.94 673.49 359.522 673.49 363.94C673.49 368.358 677.072 371.94 681.49 371.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.2 360.56C672.719 360.56 673.95 359.329 673.95 357.81C673.95 356.291 672.719 355.06 671.2 355.06C669.681 355.06 668.45 356.291 668.45 357.81C668.45 359.329 669.681 360.56 671.2 360.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.4 355.56C678.919 355.56 680.15 354.329 680.15 352.81C680.15 351.291 678.919 350.06 677.4 350.06C675.882 350.06 674.65 351.291 674.65 352.81C674.65 354.329 675.882 355.56 677.4 355.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.4 355.56C686.919 355.56 688.15 354.329 688.15 352.81C688.15 351.291 686.919 350.06 685.4 350.06C683.882 350.06 682.65 351.291 682.65 352.81C682.65 354.329 683.882 355.56 685.4 355.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.2 360.56C692.719 360.56 693.95 359.329 693.95 357.81C693.95 356.291 692.719 355.06 691.2 355.06C689.681 355.06 688.45 356.291 688.45 357.81C688.45 359.329 689.681 360.56 691.2 360.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.2 367.16C694.719 367.16 695.95 365.929 695.95 364.41C695.95 362.891 694.719 361.66 693.2 361.66C691.681 361.66 690.45 362.891 690.45 364.41C690.45 365.929 691.681 367.16 693.2 367.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.7 367.16C671.219 367.16 672.45 365.929 672.45 364.41C672.45 362.891 671.219 361.66 669.7 361.66C668.181 361.66 666.95 362.891 666.95 364.41C666.95 365.929 668.181 367.16 669.7 367.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.8 373.81C692.319 373.81 693.55 372.579 693.55 371.06C693.55 369.541 692.319 368.31 690.8 368.31C689.281 368.31 688.05 369.541 688.05 371.06C688.05 372.579 689.281 373.81 690.8 373.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.2 373.91C673.719 373.91 674.95 372.679 674.95 371.16C674.95 369.641 673.719 368.41 672.2 368.41C670.681 368.41 669.45 369.641 669.45 371.16C669.45 372.679 670.681 373.91 672.2 373.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.2 378.26C686.719 378.26 687.95 377.029 687.95 375.51C687.95 373.991 686.719 372.76 685.2 372.76C683.681 372.76 682.45 373.991 682.45 375.51C682.45 377.029 683.681 378.26 685.2 378.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.2 378.26C679.719 378.26 680.95 377.029 680.95 375.51C680.95 373.991 679.719 372.76 678.2 372.76C676.681 372.76 675.45 373.991 675.45 375.51C675.45 377.029 676.681 378.26 678.2 378.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.59 380.14L681.2 363.91L662.59 380.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.59 380.14L681.2 363.91",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.68 363.46L703.05 373.91L680.68 363.46Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.68 363.46L703.05 373.91",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.87 339.39L681.12 363.98L678.87 339.39Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.87 339.39L681.12 363.98",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.67 355.35H769.95V372.88H808.67V355.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.75 346.98H776.67V355.48H800.75V346.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.71 345.23C794.691 345.23 799.54 340.381 799.54 334.4C799.54 328.419 794.691 323.57 788.71 323.57C782.729 323.57 777.88 328.419 777.88 334.4C777.88 340.381 782.729 345.23 788.71 345.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.51 334.15L793.24 327.48L788.51 334.15Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.51 334.15L793.24 327.48",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.71 335.9C789.483 335.9 790.11 335.273 790.11 334.5C790.11 333.727 789.483 333.1 788.71 333.1C787.936 333.1 787.31 333.727 787.31 334.5C787.31 335.273 787.936 335.9 788.71 335.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7 197.69H94.21V253.77H99.7V197.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8892 255.59H64.9492V259.25H86.8892V255.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8594 317.44C84.9894 324.44 93.8594 324.22 96.2694 317.59L97.4094 313.17",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8594 317.44C84.9894 324.44 93.8594 324.22 96.2694 317.59L97.4094 313.17",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1396 412.08H82.7397L82.8197 316.24L69.1396 316.08V412.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9097 412.22L79.7297 316.22H69.1396V412.14L79.9097 412.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2792 312.89H64.9492V316.55H86.2792V312.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 258.64H50.9297V313.5H102.13V258.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3 262.3H53.3701V310.45H100.3V262.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0595 301.57C66.0066 302.72 65.6171 303.83 64.9392 304.761C64.2614 305.692 63.3251 306.403 62.2465 306.807C61.1679 307.211 59.9946 307.289 58.8721 307.031C57.7496 306.774 56.7273 306.193 55.9322 305.36C55.1371 304.527 54.604 303.478 54.3993 302.345C54.1946 301.212 54.3272 300.043 54.7806 298.985C55.234 297.926 55.9883 297.024 56.9498 296.39C57.9114 295.757 59.0378 295.419 60.1895 295.42C60.9792 295.437 61.7578 295.609 62.4806 295.928C63.2035 296.246 63.8563 296.704 64.4017 297.276C64.947 297.847 65.3742 298.521 65.6587 299.258C65.9432 299.994 66.0794 300.78 66.0595 301.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2494 301.6C78.1907 302.749 77.7964 303.855 77.1152 304.782C76.434 305.709 75.496 306.416 74.4171 306.815C73.3383 307.214 72.1661 307.288 71.0457 307.027C69.9253 306.767 68.9059 306.183 68.1137 305.349C67.3215 304.515 66.7914 303.467 66.5889 302.335C66.3864 301.203 66.5205 300.036 66.9745 298.979C67.4285 297.922 68.1826 297.022 69.1433 296.389C70.104 295.756 71.2291 295.419 72.3794 295.42C73.1717 295.437 73.9528 295.61 74.6777 295.931C75.4025 296.251 76.0567 296.712 76.6025 297.286C77.1483 297.861 77.5748 298.538 77.8575 299.278C78.1402 300.019 78.2734 300.808 78.2494 301.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4393 301.55C90.3903 302.701 90.004 303.813 89.3284 304.747C88.6528 305.681 87.7177 306.395 86.6393 306.802C85.5609 307.208 84.3868 307.289 83.2629 307.034C82.139 306.779 81.1148 306.199 80.3177 305.367C79.5206 304.534 78.9857 303.486 78.7795 302.352C78.5732 301.218 78.7048 300.049 79.1578 298.989C79.6108 297.929 80.3652 297.026 81.3273 296.391C82.2894 295.757 83.4168 295.419 84.5693 295.42C85.3573 295.437 86.1342 295.609 86.8557 295.926C87.5772 296.243 88.2291 296.7 88.7743 297.269C89.3194 297.838 89.747 298.509 90.0327 299.244C90.3184 299.978 90.4565 300.762 90.4393 301.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7893 301.51C63.7913 302.179 63.5945 302.834 63.2238 303.391C62.8532 303.949 62.3254 304.384 61.7074 304.641C61.0894 304.898 60.4089 304.966 59.7523 304.835C59.0958 304.705 58.4926 304.383 58.0193 303.91C57.546 303.437 57.2239 302.833 57.0938 302.177C56.9637 301.52 57.0314 300.84 57.2885 300.222C57.5456 299.604 57.9803 299.076 58.5377 298.705C59.0951 298.335 59.7499 298.138 60.4193 298.14C61.3131 298.14 62.1702 298.495 62.8022 299.127C63.4342 299.759 63.7893 300.616 63.7893 301.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9797 301.51C75.9817 302.179 75.7849 302.834 75.4142 303.391C75.0436 303.949 74.5158 304.384 73.8978 304.641C73.2798 304.898 72.5994 304.966 71.9428 304.835C71.2862 304.705 70.683 304.383 70.2097 303.91C69.7364 303.437 69.4143 302.833 69.2842 302.177C69.1541 301.52 69.2219 300.84 69.4789 300.222C69.736 299.604 70.1708 299.076 70.7281 298.705C71.2855 298.335 71.9404 298.138 72.6097 298.14C73.5035 298.14 74.3607 298.495 74.9927 299.127C75.6247 299.759 75.9797 300.616 75.9797 301.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1701 301.51C88.1721 302.179 87.9753 302.834 87.6047 303.391C87.234 303.949 86.7063 304.384 86.0882 304.641C85.4702 304.898 84.7898 304.966 84.1332 304.835C83.4766 304.705 82.8734 304.383 82.4001 303.91C81.9268 303.437 81.6047 302.833 81.4746 302.177C81.3445 301.52 81.4123 300.84 81.6694 300.222C81.9264 299.604 82.3612 299.076 82.9186 298.705C83.4759 298.335 84.1308 298.138 84.8001 298.14C85.2431 298.139 85.6819 298.225 86.0913 298.394C86.5008 298.563 86.8728 298.811 87.186 299.124C87.4992 299.437 87.7474 299.809 87.9163 300.219C88.0852 300.628 88.1715 301.067 88.1701 301.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8099 265.95H97.8599C98.1834 265.95 98.4938 266.078 98.7226 266.307C98.9513 266.536 99.0799 266.846 99.0799 267.17V292.17C99.0812 292.331 99.0506 292.49 98.9897 292.638C98.9289 292.787 98.8391 292.922 98.7255 293.036C98.612 293.149 98.4769 293.239 98.3283 293.3C98.1797 293.361 98.0205 293.391 97.8599 293.39H55.8099C55.6493 293.391 55.4901 293.361 55.3414 293.3C55.1928 293.239 55.0578 293.149 54.9442 293.036C54.8307 292.922 54.7409 292.787 54.68 292.638C54.6192 292.49 54.5886 292.331 54.5899 292.17V267.17C54.5899 266.846 54.7184 266.536 54.9472 266.307C55.176 266.078 55.4863 265.95 55.8099 265.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8693 268.39H57.0293V290.94H97.8693V268.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5999 253.76H101.52C101.843 253.76 102.154 253.889 102.383 254.117C102.611 254.346 102.74 254.656 102.74 254.98V257.42C102.74 257.744 102.611 258.054 102.383 258.283C102.154 258.511 101.843 258.64 101.52 258.64H93.5999C93.2763 258.64 92.966 258.511 92.7372 258.283C92.5084 258.054 92.3799 257.744 92.3799 257.42V254.98C92.3799 254.656 92.5084 254.346 92.7372 254.117C92.966 253.889 93.2763 253.76 93.5999 253.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4293 190.37H100.299C100.946 190.37 101.567 190.627 102.025 191.085C102.482 191.542 102.739 192.163 102.739 192.81V195.86C102.739 196.507 102.482 197.128 102.025 197.585C101.567 198.043 100.946 198.3 100.299 198.3H95.4293C94.7821 198.3 94.1615 198.043 93.7039 197.585C93.2463 197.128 92.9893 196.507 92.9893 195.86V192.81C92.9893 192.163 93.2463 191.542 93.7039 191.085C94.1615 190.627 94.7821 190.37 95.4293 190.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7393 193.63H64.7393H92.7393Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7393 193.63H64.7393",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3701 179V207.65V179Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3701 179V207.65",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4102 181.51V205.28V181.51Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4102 181.51V205.28",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4102 184.6V202.35V184.6Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4102 184.6V202.35",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5195 188.29V199.99V188.29Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5195 188.29V199.99",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8701 190.73V196.48V190.73Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8701 190.73V196.48",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5596 191.95V195.46V191.95Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5596 191.95V195.46",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.82 736.18V503.38L620.74 495.95V736.64L578.82 736.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.62 726.72H571.94V758.94H630.62V726.72Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66 281.08H288.94V298.61H327.66V281.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66 281.08H197.94V298.61H236.66V281.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_3808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3058_3808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 852.21,
    height: 592.11,
    fill: "white",
    transform: "translate(0 178)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjection);
export default __webpack_public_path__ + "static/media/injection.9744baee55b16bd7c30c20605918a377.svg";
export { ForwardRef as ReactComponent };